import { Button } from '@bfa/base-ui';
import React from 'react';
import { AnalyticsLink } from '../../../../../../../components/Analytics';
import { REFRESHMENTS_URLS } from '../../../../../../../constants';
import { SUBSCRIBED_LANDING_NEXT_SHIPMENT_SUMMARY_SECTION_EVENTS as EVENTS } from '../../../../../../../utils/analytics/events';
import { ButtonsWrapper, CenteredMarkdown, Container, SpacedMarkdown, } from '../../DetailedNextShipmentSummary.styled';
var EmptyShipmentSummary = function (_a) {
    var content = _a.content;
    return (React.createElement(Container, { "data-testid": "empty-next-shipment-section" },
        React.createElement(CenteredMarkdown, null, (content === null || content === void 0 ? void 0 : content.title) || ''),
        React.createElement(SpacedMarkdown, null, (content === null || content === void 0 ? void 0 : content.subtitle) || ''),
        React.createElement(ButtonsWrapper, null,
            React.createElement(AnalyticsLink, { eventData: EVENTS.CLICK_ON_MANAGE_ITEMS_LINK, href: REFRESHMENTS_URLS.MANAGE_ITEMS, passHref: true },
                React.createElement(Button, { variant: "secondary", "data-testid": "manage-shipments-button", small: true }, content === null || content === void 0 ? void 0 : content.secondaryButtonText)))));
};
export default EmptyShipmentSummary;
